import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20minimalist%20geometric%20composition%20with%20flowing%20organic%20shapes%20in%20cream%20beige%20sand%20and%20terracotta%20tones%2C%20smooth%20gradient%20layers%20with%20subtle%20texture%2C%20modern%20artistic%20background%20with%20soft%20diffused%20light%2C%20no%20sharp%20edges%2C%20peaceful%20harmonious%20warm%20color%20palette%2C%20elegant%20editorial%20quality%2C%20clean%20contemporary%20design%2C%20delicate%20overlapping%20transparent%20forms&width=1920&height=1080&seq=hero-main-2026-v2&orientation=landscape"
          alt="ACBuy Spreadsheet product comparison database background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-24 pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/20 mb-6">
            Updated Daily · 14 Categories · 1000+ Verified Items
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
            ACBuy Spreadsheet <br />
            <span className="text-primary-300">The Most Updated Product</span>
            <br />
            Comparison Database (2026)
          </h1>

          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Find the best products, lowest prices, and most trusted listings from the ACBuy Spreadsheet system
            — updated daily for global buyers comparing shoes, clothing, accessories and more with verified
            ratings and shipping data.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
            >
              <i className="ri-search-line mr-2"></i>
              acbuy spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 border-2 border-background-50/40 hover:bg-background-50 hover:text-foreground-900 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
            <Link
              to="/article/acbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
            >
              <span>Read the Complete ACBuy Spreadsheet Guide</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/shopping-guide"
              className="inline-flex items-center gap-2 text-sm text-background-50/60 hover:text-background-50 transition-colors duration-200"
            >
              <span>Shopping Guide for Beginners</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}